import { Spin } from 'antd'

export function PageLoading({ tip = '加载中…' }: { tip?: string }) {
  return (
    <div className="page-loading">
      <Spin description={tip} />
    </div>
  )
}
